export function formatDate(date, fmt) {
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  const o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds()
  }
  for (const k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
      const str = o[k] + ''
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : padLeftZero(str))
    }
  }
  return fmt
}

function padLeftZero(str) {
  return ('00' + str).substr(str.length)
}

export function getNowTimestamp() {
  var timestamp = (new Date()).getTime()
  return timestamp
}


export function getTimeFormat() {
  var d = new Date()
  // var y = d.getFullYear()
  var m = d.getMonth() + 1
  var ds = d.getDate()
  if (ds <= 9) {
    ds = '' + ds
  }
  var h = d.getHours()
  if (h <= 9) {
    h = '0' + h
  }
  var f = d.getMinutes()
  if (f <= 9) {
    f = '0' + f
  }
  var s = d.getSeconds()
  if (s <= 9) {
    s = '0' + s
  }
  var days = d.getDay()
  switch (days) {
    case 1:
      days = '星期一'
      break
    case 2:
      days = '星期二'
      break
    case 3:
      days = '星期三'
      break
    case 4:
      days = '星期四'
      break
    case 5:
      days = '星期五'
      break
    case 6:
      days = '星期六'
      break
    case 0:
      days = '星期日'
      break
  }

  return /*y + '年' + */ m + '月' + ds + '日' /* + h + ':' + f + ':' + s */ + ' ' + days
}